import { FC } from "react"
import classes from "./styles.module.scss"
import { Flex, NumberInput, RangeSlider, Divider, RangeSliderValue } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { FilterFormValues } from "../../lib"

interface FilterRangeInputProps {
	name: string
	label?: string
	defaultValue: [number, number]
	form: UseFormReturnType<FilterFormValues>
}

export const FilterRangeInput: FC<FilterRangeInputProps> = ({
	name,
	label,
	defaultValue,
	form,
}) => {
	const formValue = form.values[name]
	const currentValue = Array.isArray(formValue) ? (formValue as [number, number]) : defaultValue
	const minDefault = defaultValue[0]
	const maxDefault = defaultValue[1]
	const [min, max] = currentValue

	const handleRangeChange = (value: RangeSliderValue) => {
		form.setFieldValue(name, value)
	}

	const handleInputChange = (value: [unknown, unknown], type: "min" | "max") => {
		if (type === "min") {
			if (typeof value[0] !== "number") return

			form.setFieldValue(name, [
				value[0],
				value[0] > max && value[0] <= maxDefault
					? value[0]
					: value[0] > maxDefault
					? maxDefault
					: max,
			])
		} else {
			if (typeof value[1] !== "number") return
			form.setFieldValue(name, [
				value[1] < min && value[1] >= minDefault
					? value[1]
					: value[1] < minDefault
					? minDefault
					: min,
				value[1],
			])
		}
	}

	return (
		<div className={classes.container}>
			<div className={classes.label}>{label}</div>
			<Flex className={classes.inputs}>
				<NumberInput
					prefix="от "
					defaultValue={minDefault}
					value={min}
					min={minDefault}
					max={maxDefault}
					thousandSeparator=" "
					hideControls
					classNames={{ input: classes.input }}
					onChange={value => handleInputChange([value, max], "min")}
				/>
				<Divider orientation="vertical" color="gray.1" size={2} />
				<NumberInput
					prefix="до "
					defaultValue={maxDefault}
					value={max}
					min={minDefault}
					max={maxDefault}
					thousandSeparator=" "
					hideControls
					classNames={{ input: classes.input }}
					onChange={value => handleInputChange([min, value], "max")}
				/>
			</Flex>
			<div className={classes.slider}>
				<RangeSlider
					size={1}
					min={minDefault}
					max={maxDefault}
					value={currentValue}
					label={null}
					onChange={handleRangeChange}
					thumbSize={12}
					minRange={0}
					color="green.0"
				/>
			</div>
		</div>
	)
}
